import { createSlice } from '@reduxjs/toolkit';
import { ExternalVideoState } from './types';

const initialState: ExternalVideoState = {
  FObjects: '',
};

const externaVideoSlice = createSlice({
  name: 'video',
  initialState,
  reducers: {
    setVideoFilter: (state, { payload }) => {
      state.FObjects = payload;
    },
    clearVideoFilter: (state) => {
      state.FObjects = '';
    },
  },
});

export const { setVideoFilter, clearVideoFilter } = externaVideoSlice.actions;
export default externaVideoSlice.reducer;
